import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Plus, Pencil, Trash2, X, UserCheck, UserX, Crown } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

// >>> PLENARIUM:LEITURAS -- cargos da Mesa Diretora
// So o PRESIDENTE tem os poderes de Presidente no sistema. O 1o e o 2o
// Secretario ganham a tela "Leituras" no tablet. Os demais cargos sao
// so informativos (aparecem nas telas e na TV).
const CARGOS = [
  ['VEREADOR', 'Vereador(a)'],
  ['PRESIDENTE', 'Presidente'],
  ['VICE_PRESIDENTE', '1º Vice-Presidente'],
  ['SEGUNDO_VICE_PRESIDENTE', '2º Vice-Presidente'],
  ['PRIMEIRO_SECRETARIO', '1º Secretário(a)'],
  ['SEGUNDO_SECRETARIO', '2º Secretário(a)'],
  ['TESOUREIRO', 'Tesoureiro(a)']
];
const ROTULO_CARGO = Object.fromEntries(CARGOS);
const COR_CARGO = { PRESIDENTE: 'badge-amarelo', VICE_PRESIDENTE: 'badge-indigo', SEGUNDO_VICE_PRESIDENTE: 'badge-indigo', PRIMEIRO_SECRETARIO: 'badge-verde', SEGUNDO_SECRETARIO: 'badge-verde', TESOUREIRO: 'badge-indigo' };
// <<< PLENARIUM:LEITURAS

export default function Vereadores() {
  const { usuario } = useAuth();

  // ✅ CORRIGIDO: camaraId vem do contexto, não hardcoded
  const VAZIO = {
    nome: '', nomeParlamentar: '', partido: '', cpf: '', email: '',
    telefone: '', senha: '', fotoUrl: '',
    cargo: 'VEREADOR', sexo: '', camaraId: usuario?.camaraId || ''
  };

  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(VAZIO);
  const [editandoId, setEditandoId] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const carregar = async () => {
    setLoading(true);
    try {
      const r = await axios.get('/api/vereadores');
      setLista(r.data);
    } catch { toast.error('Erro ao carregar vereadores'); }
    finally { setLoading(false); }
  };

  useEffect(() => { carregar(); }, []);

  // >>> PLENARIUM:VEREADOR_ONLINE -- quem esta com o painel aberto agora
  const [online, setOnline] = useState({});
  useEffect(() => {
    let vivo = true;
    const ler = () => axios.get('/api/acesso-vereador/online').then(r => { if (!vivo) return; const m = {}; (Array.isArray(r.data) ? r.data : []).forEach(o => { m[o.vereadorId] = o; }); setOnline(m); }).catch(() => {});
    ler(); const t = setInterval(ler, 15000);
    return () => { vivo = false; clearInterval(t); };
  }, []);
  const horaOnline = (d) => { try { return new Date(d).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; } };
  // PLENARIUM:ACESSO_HORARIOS -- hora da ultima entrada e saida de cada vereador
  const [ultimos, setUltimos] = useState({});
  useEffect(() => {
    let vivo = true;
    const ler = () => axios.get('/api/acesso-vereador/ultimos').then(r => { if (!vivo) return; const m = {}; (Array.isArray(r.data) ? r.data : []).forEach(o => { m[o.vereadorId] = o; }); setUltimos(m); }).catch(() => {});
    ler(); const t = setInterval(ler, 15000);
    return () => { vivo = false; clearInterval(t); };
  }, []);
  const quando = (d) => { const x = new Date(d); if (isNaN(x.getTime())) return ''; const hoje = x.toDateString() === new Date().toDateString(); return (hoje ? '' : x.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) + ' ') + 'às ' + horaOnline(x); };
  const textoSaida = (id) => { const u = ultimos[id]; if (!u) return 'Desconectado'; if (u.saiuEm) return `Saiu ${quando(u.saiuEm)}`; if (u.entrouEm) return `Desconectado · último acesso ${quando(u.entrouEm)}`; return 'Desconectado'; };
  // <<< PLENARIUM:VEREADOR_ONLINE

  const abrirNovo = () => {
    setForm({ ...VAZIO, camaraId: usuario?.camaraId || '' });
    setEditandoId(null);
    setModal(true);
  };

  const abrirEditar = (v) => {
    setForm({
      nome: v.nome, nomeParlamentar: v.nomeParlamentar || '', partido: v.partido, cpf: v.cpf,
      email: v.email || '', telefone: v.telefone || '',
      senha: '', fotoUrl: v.fotoUrl || '',
      cargo: v.cargo || 'VEREADOR', sexo: v.sexo || '', camaraId: v.camaraId
    });
    setEditandoId(v.id);
    setModal(true);
  };

  const formatCPF = (v) => v.replace(/\D/g, '').slice(0, 11)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  const salvar = async (e) => {
    e.preventDefault();

    // PLENARIUM:LEITURAS -- cada cargo da Mesa costuma ter uma pessoa so: avisa antes de repetir
    if (form.cargo && form.cargo !== 'VEREADOR') {
      const outro = lista.find(v => v.cargo === form.cargo && v.id !== editandoId && v.ativo !== false);
      if (outro) {
        const confirmar = window.confirm(
          `${outro.nome} já está cadastrado(a) como ${ROTULO_CARGO[form.cargo]}.\n\nSe continuar, os dois ficarão com o mesmo cargo. Para trocar, edite antes o cadastro de ${outro.nome} e coloque "Vereador(a)".\n\nDeseja continuar mesmo assim?`
        );
        if (!confirmar) return;
      }
    }

    setSalvando(true);
    try {
      if (editandoId) {
        await axios.put(`/api/vereadores/${editandoId}`, form);
        toast.success('Vereador atualizado!');
      } else {
        await axios.post('/api/vereadores', form);
        toast.success('Vereador cadastrado!');
      }
      setModal(false);
      carregar();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao salvar');
    } finally { setSalvando(false); }
  };

  const excluir = async (id, nome) => {
    if (!window.confirm(`Remover ${nome}?`)) return;
    try {
      await axios.delete(`/api/vereadores/${id}`);
      toast.success('Vereador removido');
      carregar();
    } catch { toast.error('Erro ao remover'); }
  };

  const PARTIDOS = ['PT','PSDB','PL','MDB','PP','PDT','PSB','PODE','REPUBLICANOS','UNIÃO','PSD','AVANTE','SOLIDARIEDADE','PROS','DC','PATRIOTA','PSC','PMN','PCdoB','PSOL','REDE','PV','CIDADANIA','AGIR'];

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Vereadores</h1>
          <p className="page-subtitle">{lista.length} cadastrado(s) · <span style={{ color: '#15803d', fontWeight: 700 }}>{lista.filter(v => online[v.id]).length} conectado(s) agora</span></p> {/* PLENARIUM:VEREADOR_ONLINE */}
        </div>
        <button className="btn btn-primary" onClick={abrirNovo}>
          <Plus size={15} /> Novo Vereador
        </button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        {loading ? (
          <div className="loading-screen" style={{ minHeight: 220 }}><div className="spinner" /></div>
        ) : lista.length === 0 ? (
          <div className="sem-dados"><p>Nenhum vereador cadastrado.</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Vereador</th>
                  <th>Partido</th>
                  <th>Cargo</th>
                  <th>CPF</th>
                  <th>E-mail</th>
                  <th>Status</th>
                  <th style={{ width: 90 }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(v => (
                  <tr key={v.id}>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        {v.fotoUrl ? (
                          <img src={v.fotoUrl} alt={v.nome} className="avatar" style={{ width: 60, height: 80, borderRadius: 8, objectFit: 'contain', background: '#f1f5f9' }} />
                        ) : (
                          <div className="avatar-placeholder" style={{ width: 60, height: 80, borderRadius: 8, fontSize: '0.95rem' }}>
                            {v.nome.split(' ').map(n => n[0]).slice(0,2).join('')}
                          </div>
                        )}
                        <span style={{ fontWeight: 600 }}>{v.nome}</span>
                      </div>
                    </td>
                    <td><span className="badge badge-indigo">{v.partido}</span></td>
                    <td>
                      {v.cargo === 'PRESIDENTE'
                        ? <span className="badge badge-amarelo"><Crown size={11} /> Presidente</span>
                        : v.cargo && v.cargo !== 'VEREADOR'
                          ? <span className={`badge ${COR_CARGO[v.cargo] || 'badge-indigo'}`}>{ROTULO_CARGO[v.cargo] || v.cargo}</span>
                          : <span className="badge badge-cinza">Vereador</span>
                      }
                    </td>
                    <td><span className="font-mono" style={{ fontSize: '0.8rem' }}>{v.cpf}</span></td>
                    <td style={{ color: 'var(--texto-suave)' }}>{v.email || '—'}</td>
                    <td>
                      {v.ativo
                        ? <span className="badge badge-verde"><UserCheck size={11} /> Ativo</span>
                        : <span className="badge badge-vermelho"><UserX size={11} /> Inativo</span>
                      }
                      {/* PLENARIUM:VEREADOR_ONLINE */}
                      <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.75rem', fontWeight: 600, color: online[v.id] ? '#15803d' : '#94a3b8', whiteSpace: 'nowrap' }}>
                        <span style={{ width: 8, height: 8, borderRadius: '50%', flexShrink: 0, background: online[v.id] ? '#22c55e' : '#cbd5e1', boxShadow: online[v.id] ? '0 0 0 3px rgba(34,197,94,.18)' : 'none' }} />
                        {online[v.id] ? `Conectado desde ${horaOnline(online[v.id].desde)}${online[v.id].aparelhos > 1 ? ` · ${online[v.id].aparelhos} aparelhos` : ''}` : textoSaida(v.id)}{/* PLENARIUM:ACESSO_HORARIOS */}
                      </div>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <button className="btn btn-secondary btn-sm" onClick={() => abrirEditar(v)}>
                          <Pencil size={13} />
                        </button>
                        <button className="btn btn-secondary btn-sm" title="Desconectar todos os aparelhos (tablets/celulares) deste vereador" onClick={async () => { if (!window.confirm(`Desconectar todos os aparelhos de ${v.nome}?\n\nO login dele deixa de valer em todos os tablets e celulares e ele precisará entrar de novo com CPF e senha.`)) return; try { await axios.post(`/api/acesso-vereador/${v.id}/desconectar`); toast.success('Aparelhos desconectados.'); } catch (e) { toast.error((e && e.response && e.response.data && e.response.data.error) || 'Não foi possível desconectar.'); } }}> {/* PLENARIUM:ACESSO */}
                          <UserX size={13} /> Desconectar
                        </button>
                        <button className="btn btn-danger btn-sm" onClick={() => excluir(v.id, v.nome)}>
                          <Trash2 size={13} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxHeight: 'calc(100vh - 32px)', overflowY: 'auto' }}> {/* PLENARIUM:LEITURAS -- rola quando nao cabe */}
            <div className="modal-header">
              <h2 className="modal-title">{editandoId ? 'Editar Vereador' : 'Novo Vereador'}</h2>
              <button className="btn-modal-close" onClick={() => setModal(false)}><X size={18} /></button>
            </div>
            <form onSubmit={salvar}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group" style={{ gridColumn: '1/-1' }}>
                  <label className="form-label">Nome Completo *</label>
                  <input className="form-input" value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required />
                  <p style={{ fontSize: '0.7rem', color: 'var(--texto-suave)', marginTop: 4 }}>Usado na ata, na lista de presença e em todos os documentos oficiais.</p>
                </div>
                <div className="form-group">
                  <label className="form-label">Nome Parlamentar</label>
                  <input
                    className="form-input"
                    value={form.nomeParlamentar}
                    onChange={e => setForm({ ...form, nomeParlamentar: e.target.value })}
                    placeholder="Como é conhecido publicamente (opcional)"
                  />
                  <p style={{ fontSize: '0.7rem', color: 'var(--texto-suave)', marginTop: 4 }}>Aparece apenas no Painel de TV e no painel do vereador. Em branco, usa-se o nome completo.</p>
                </div>
                <div className="form-group">
                  <label className="form-label">Partido *</label>
                  <select className="form-input form-select" value={form.partido} onChange={e => setForm({ ...form, partido: e.target.value })} required>
                    <option value="">Selecione</option>
                    {PARTIDOS.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Cargo na Mesa Diretora *</label>
                  <select className="form-input form-select" value={form.cargo} onChange={e => setForm({ ...form, cargo: e.target.value })}>
                    {CARGOS.map(([v, r]) => <option key={v} value={v}>{r}</option>)}
                  </select>
                  <p style={{ fontSize: '0.7rem', color: 'var(--texto-suave)', marginTop: 4 }}>
                    {form.cargo === 'PRIMEIRO_SECRETARIO' || form.cargo === 'SEGUNDO_SECRETARIO'
                      ? 'O Secretário(a) terá no tablet a tela "Leituras": ata anterior, Expediente e matérias da Ordem do Dia.'
                      : form.cargo === 'PRESIDENTE' ? 'O Presidente pode abrir e encerrar votações pelo tablet.' : 'Cargo exibido nas telas e no Painel de TV.'}
                  </p>
                </div>
                <div className="form-group">
                  <label className="form-label">Sexo</label>
                  <select className="form-input form-select" value={form.sexo} onChange={e => setForm({ ...form, sexo: e.target.value })}>
                    <option value="">Não informado</option>
                    <option value="M">Masculino</option>
                    <option value="F">Feminino</option>
                  </select>
                  <p style={{ fontSize: '0.7rem', color: 'var(--texto-suave)', marginTop: 4 }}>Define o tratamento: Vereador ou Vereadora, nas telas e nos documentos. O cargo de Presidente não varia.</p>
                </div>
                <div className="form-group">
                  <label className="form-label">CPF *</label>
                  <input className="form-input" value={form.cpf} onChange={e => setForm({ ...form, cpf: formatCPF(e.target.value) })} required />
                </div>
                <div className="form-group">
                  <label className="form-label">E-mail</label>
                  <input className="form-input" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">Telefone</label>
                  <input className="form-input" value={form.telefone} onChange={e => setForm({ ...form, telefone: e.target.value })} />
                </div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}>
                  <label className="form-label">Foto do Vereador</label>
                  <input type="file" accept="image/*" className="form-input"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (!file) return;
                      if (file.size > 2 * 1024 * 1024) { alert('A foto deve ter no máximo 2MB!'); return; }
                      const reader = new FileReader();
                      reader.onload = () => setForm({ ...form, fotoUrl: reader.result });
                      reader.readAsDataURL(file);
                    }}
                  />
                  {form.fotoUrl && (
                    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 12 }}>
                      <img src={form.fotoUrl} alt="Preview" className="avatar" style={{ width: 56, height: 56, border: '2px solid var(--acento)' }} />
                      <button type="button" className="btn btn-danger btn-sm" onClick={() => setForm({ ...form, fotoUrl: '' })}>Remover</button>
                    </div>
                  )}
                </div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}>
                  <label className="form-label">{editandoId ? 'Nova Senha (deixe vazio para manter)' : 'Senha *'}</label>
                  <input className="form-input" type="password" autoComplete="new-password" name="nova-senha-vereador" value={form.senha} onChange={e => setForm({ ...form, senha: e.target.value })} required={!editandoId} />
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
